import type { FC } from 'react';

import { CenterContainer } from '@xing-com/platform-layout-view-wrapper';
import { spaceXL } from '@xing-com/tokens';

import { useCompaniesArticles } from '../../hooks/use-companies-articles/use-companies-articles';
import * as Styled from './section-companies-insights.styles';

const LIMIT = 3;

export const SectionCompaniesInsights: FC = () => {
  const { data, loading } = useCompaniesArticles({ limit: LIMIT });

  const companyArticles = data?.companyArticles?.collection ?? [];

  const contentCardContent = companyArticles.map((article) => ({
    title: article?.details?.title ?? '',
    description: article?.details?.description ?? '',
    readingTime: article?.readingTime,
    image: article?.details?.image,
    bgColor: article?.bgColor,
    href: article?.details?.url,
    to: article?.details?.url,
  }));

  return (
    <CenterContainer>
      <Styled.CarouselSection
        titleKey="CP_INSIGHTS_SECTION_TITLE"
        subtitleKey="CP_INSIGHTS_SECTION_SUBLINE"
        variant="custom"
        useFullWidth
        itemWidth="284px"
        itemWidthWide="752px"
        itemWidthConfined="649px"
        paddingBottom={spaceXL}
        paddingTop={spaceXL}
      >
        {!loading &&
          contentCardContent.map((data, index) => (
            // @ts-expect-error FIXME: SC6
            <Styled.ContentCard
              data-testid={`company-insight-card-${index}`}
              key={index}
              variant="hero"
              {...data}
            />
          ))}
      </Styled.CarouselSection>
    </CenterContainer>
  );
};
